// extracted by mini-css-extract-plugin
export default {"titlePerfil":"perfil_titlePerfil__Z1jk6","containerPerfil":"perfil_containerPerfil__87+1D"};